<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<h1 class="booktitle">A Warrior’s Passion</h1>
<h3 class="author">Margaret Moore<br/><br/><br/></h3>
<p class="publogo"><img alt="publisher logo" src="images/logo.jpg"/></p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005-titlepage.vue?9d31d838